export default __webpack_public_path__ + "images/7J.f124001.png";